const sideBarRightTop: adUnit = {
  element: "sidebar_right_mid",
  gamCode: "/21841313772,22653506037/wso/sidebar_right_mid",
  sizes: {
    mobile: [[250, 250]],
    tablet: [[250, 250]],
    desktop: [[300, 250]],
  },
  sizeMapping: [
    {
      viewPortSize: [1200, 250],
      sizes: [[300, 250]],
    },
    {
      viewPortSize: [992, 250],
      sizes: [[250, 250]],
    },
    {
      viewPortSize: [0, 0],
      sizes: [],
    },
  ],
  vendors: {
    amazon: true,
    prebid: {
      enabled: true,
      mediaTypes: {
        banner: {
          sizeConfig: [
            { minViewPort: [0, 0], sizes: [] },
            { minViewPort: [992, 0], sizes: [[250, 250]] },
            { minViewPort: [1200, 0], sizes: [[300, 250]] },
          ],
        },
      },
      bids: [
        {
          bidder: 'equativ',
          params: {
            networkId: 5632,
          },
        },
        {
          bidder: "ix",
          params: {
            siteId: "957827",
          },
        },
        {
          bidder: "medianet",
          params: {
            cid: "8CUZX691M",
            crid: "732869840",
          },
        },
        {
          bidder: "nativo",
          params: {
            placementId: 1467953,
          },
        },
        {
          bidder: "oms",
          params: {
            publisherId: 20931,
          },
        },
        {
          bidder: "onetag",
          params: {
            pubId: "76b2c6676b744dc",
          },
        },
        {
          bidder: "pubmatic",
          params: {
            publisherId: "158347",
            adSlot: "4968129",
          },
        },
        {
          bidder: "rubicon",
          params: {
            accountId: "20438",
            siteId: "470922",
            zoneId: "2787322",
          },
        },
        {
          bidder: "sovrn",
          params: {
            tagid: "1116263", // 300x250
          },
          sizeConfig: [
            { minViewPort: [0, 0], relevantMediaTypes: ["none"] },
            { minViewPort: [768, 0], relevantMediaTypes: ["none"] },
            { minViewPort: [1200, 0], relevantMediaTypes: ["banner"] },
          ],
        },
        {
          bidder: "nobid",
          params: {
            siteId: 198057,
          },
        },
      ],
    },
  },
};

export default sideBarRightTop;
